import { Tag } from "antd"


const MetadataTag: React.FC<{name: string, label: string}> = ({name,label}) => {

    return (
        <Tag>
            <div style={{display: 'flex', gap: '0.25rem'}}>
            <span style={{fontSize: '10px', fontWeight: 'bold'}}>{name}:</span>
            <span style={{fontSize: '10px'}}>{label}</span>
            </div>
        </Tag>
    )

}

export default MetadataTag